import React, { useEffect, useState, useRef } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import Dropdown from 'components/Dropdown/Dropdown';
import { Icon } from 'components/ui';
import {
    colors, space, fontWeights, lineHeights
} from 'style/config';
import { contextHasChanged, getContextAwarePlacement } from 'ai/utils/aiBeautyChat';
import AIBeautyChatContent from 'ai/components/AIBeautyChatDrop/AIBeautyChatContent.f';
import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import anaUtils from 'analytics/utils';

const AIBeautyChatDrop = props => {
    const [isOpen, setIsOpen] = useState(false);
    const {
        dropWidth,
        config,
        localization,
        page,
        featuresAIBeautyChat,
        contextPrompts,
        handlePromptClick,
        fetchEntryPoints,
        clientId,
        anonymousId
    } = props;

    useEffect(() => {
        if (contextHasChanged(page)) {
            const placement = getContextAwarePlacement(page);

            if (!placement) {
                fetchEntryPoints(clientId, anonymousId);
            }
        }
    }, [page]);

    // Track when ai chat dropdown opens: AC 1
    const hasTrackedFlyoutRef = useRef(false);
    useEffect(() => {
        if (isOpen && !hasTrackedFlyoutRef.current) {
            hasTrackedFlyoutRef.current = true;
            processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
                data: {
                    ...anaUtils.getLastAsyncPageLoadData(),
                    pageName: anaConsts.SUPER_CHAT.SUPERCHAT_FLYOUT
                }
            });
        } else if (!isOpen) {
            // Reset tracking flag when dropdown closes so it can track again on next open
            hasTrackedFlyoutRef.current = false;
        }
    }, [isOpen]);

    const contentProps = {
        localization,
        page,
        featuresAIBeautyChat,
        contextPrompts,
        handlePromptClick
    };

    return (
        <Dropdown
            id='aibeautychat_drop'
            hasMaxHeight={true}
            onTrigger={(_, isDropdownOpen) => {
                setIsOpen(isDropdownOpen);
            }}
        >
            <Dropdown.Trigger
                display='flex'
                alignItems='center'
                paddingX={4}
                height='100%'
                data-at={Sephora.debug.dataAt('aibeautychat_header')}
            >
                <Icon
                    name={isOpen ? 'aiBeautyActive' : 'aiBeauty'}
                    size={24}
                    marginRight={3}
                />
                <span css={styles.labelContainer}>
                    <span css={isOpen && styles.triggerLabelActive}>
                        {config?.meta?.bot_name || localization.title}
                        <span css={styles.badge}>{localization.new}</span>
                    </span>
                </span>
            </Dropdown.Trigger>
            <Dropdown.Menu
                width={dropWidth}
                minWidth='374px'
                align='center'
                paddingY={4}
                data-at={Sephora.debug.dataAt('aibeautychat_flyout_menu')}
            >
                <AIBeautyChatContent {...contentProps} />
            </Dropdown.Menu>
        </Dropdown>
    );
};

const styles = {
    triggerLabel: {
        marginLeft: space[3]
    },
    triggerLabelActive: {
        boxShadow: `0 2px 0 0 ${colors.black}`
    },
    labelContainer: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: 65,
        lineHeight: lineHeights.tight
    },
    badge: {
        padding: 2,
        color: colors.white,
        backgroundColor: colors.black,
        borderRadius: '4px',
        fontSize: '8px',
        fontWeight: fontWeights.bold,
        lineHeight: lineHeights.none,
        textTransform: 'uppercase',
        top: -2,
        left: 4,
        position: 'relative'
    }
};

export default wrapFunctionalComponent(AIBeautyChatDrop, 'AIBeautyChatDrop');
